import {buildStandardHeaders, otsBaseApi} from "../../ots-api";
import {Invoice, InvoiceEntity} from "../../../model/invoice";
import {InvoiceSearchCriteria} from "../../../model/search/invoice-search-criteria";
import {removeUndefined} from "../../../util/util";
import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {OtsAsyncThunkConfigExtra, OtsState} from "../../ots-store";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["Invoices"]});

const invoiceApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchInvoices: builder.query<
      Invoice[],
      InvoiceSearchCriteria
    >({
      query: (criteria) => ({
        url: `/invoice/search`,
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "Invoices", id} as const)),
            {type: "Invoices", id: "LIST"}
          ];
        } else {
          return [{type: "Invoices", id: "LIST"}];
        }
      },
    }),
    getInvoice: builder.query<Invoice, {
      id: string,
      database: string | undefined
    }>({
      query: ({id, database}) => ({
        url: `/invoice/${id}`,
        method: "GET",
        params: removeUndefined({
          database: database
        })
      }),
      providesTags: (result, error, arg) => [{type: "Invoices", id: arg.id}]
    }),
  })
});

export const {
  useSearchInvoicesQuery,
  useGetInvoiceQuery,
} = invoiceApi;

export const downloadInvoicePdf = (invoice: InvoiceEntity, api: BaseQueryApi): Promise<Response> => {
  const headers = buildStandardHeaders(api)
  headers["Accept"] = 'application/pdf'
  headers["Content-Type"] = 'application/json'

  const request: RequestInit = {
    method: 'GET',
    headers: headers,
  }

  const params = new URLSearchParams(removeUndefined({
    database: invoice.dbName,
    bytes: true,
  }))

  const baseUrl = (api.extra as OtsAsyncThunkConfigExtra).baseUrl;
  const url = `${baseUrl}/invoice/${invoice.id}/pdf?${params}`;

  return window.fetch(url, request)
}
